import { useEffect, useState } from 'react';
import { Box, Typography, Modal, RadioGroup, FormControlLabel, Radio, TextField, InputAdornment, IconButton, Button } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CalendarToday } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import dayjs from 'dayjs';

import useStyles from './styles';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 480,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

const Publish = ({ open, handleClose, handleSubmit, savedScheduleDate, loading, notificationStatus }) => {
    const classes = useStyles();

    const [selectedOption, setOption] = useState('publish');
    const [openCalendar, setCalendarModal] = useState(false);
    const [scheduleTime, setScheduleTime] = useState('');
    const [disableButton, setDisabledButton] = useState(false);
    const [error, setError] = useState(false);

    const handleScheduleDateChange = (event) => {
        const validDate = dayjs(event).isValid();

        if (validDate) {
            setScheduleTime(event ? dayjs(event).format('YYYY-MM-DD | hh:mm A') : '');
        }
        else setScheduleTime(event);

        const isValid = dayjs(event, 'YYYY-MM-DD | hh:mm A') && dayjs(event, 'YYYY-MM-DD | hh:mm A').isAfter(dayjs());
        setError(!isValid);
        setDisabledButton(!isValid);
    };

    const handleOptionChange = (value) => {
        setOption(value);

        let disableButton = false;
        let error = false;

        if (value === 'schedule') {
            if(scheduleTime && scheduleTime.length) {
                disableButton = !dayjs(scheduleTime, 'YYYY-MM-DD | hh:mm A').isValid() || dayjs(scheduleTime, 'YYYY-MM-DD | hh:mm A').isBefore(dayjs());
                error = disableButton;
            }
            else disableButton = true;
        }

        setDisabledButton(disableButton);
        setError(error);
    };

    useEffect(() => {
        if (savedScheduleDate && notificationStatus === 1) {
            setScheduleTime(dayjs(savedScheduleDate).format('YYYY-MM-DD | hh:mm A'));
            setOption('schedule');
            setDisabledButton(false);
        }
    }, [savedScheduleDate, notificationStatus])

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-titles" className={classes.publishModalHeading}>
                    Are you sure you want to publish this notification ?
                </Typography>
                <Typography className={classes.publishModalHeading}>
                    This will send notifications to the selected Instances
                </Typography>
                <div className={classes.publishOptions}>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        onChange={(event) => handleOptionChange(event.target.value)}
                        value={selectedOption}
                    >
                        <FormControlLabel value="publish" control={<Radio />} label="Publish Now" />
                        <FormControlLabel value="schedule" control={<Radio />} label="Schedule" />
                    </RadioGroup>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>

                        <DateTimePicker
                            onChange={(event) => handleScheduleDateChange(event)}
                            minDate={dayjs()}
                            minDateTime={dayjs()}

                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    onClick={() => {
                                        if(selectedOption === 'schedule') {
                                            setCalendarModal(true)
                                        }
                                    }}
                                    fullWidth
                                    onChange={(event) => handleScheduleDateChange(event.target.value)}
                                    inputProps={{
                                        placeholder: scheduleTime.length ? '' : 'Select Date & Time',
                                    }}
                                    InputProps={{// eslint-disable-line react/jsx-no-duplicate-props
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton onClick={() => {
                                                    if(selectedOption === 'schedule') {
                                                        setCalendarModal(true)
                                                    }
                                                }}>
                                                    <CalendarToday />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    error={error}
                                    value={scheduleTime}
                                />
                            }
                            disabled={selectedOption !== 'schedule'}
                            inputFormat='YYYY-MM-DD | hh:mm A'
                            open={openCalendar}
                            onClose={() => setCalendarModal(false)}
                            value={dayjs(scheduleTime, 'YYYY-MM-DD | hh:mm A')}
                        />
                    </LocalizationProvider>

                    <div className={classes.publishButtons}>
                        <Button className={`${classes.notificationButton} ${classes.publishButtonDimensions}`} variant="outlined" onClick={handleClose}>Cancel</Button>
                        <LoadingButton
                            loading={loading}
                            loadingIndicator="Saving"
                            variant='outlined'
                            className={`${classes.notificationButton} ${classes.publishButtonDimensions}`}
                            onClick={() => {
                                if (selectedOption === 'publish') {
                                    handleSubmit(dayjs().toISOString(), selectedOption);
                                }
                                else handleSubmit(dayjs(scheduleTime, 'YYYY-MM-DD | hh:mm A').toISOString(), selectedOption)
                            }}
                            disabled={disableButton}
                        >
                            {!loading && 'Confirm'}
                        </LoadingButton>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default Publish;